import { FC } from 'react';
import { Files } from './files';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { useMutation, useQuery } from '@apollo/client';
import { StaffCasesFilesContainerCredentialVerificationCaseV1Document, StaffCasesFilesContainerCredentialVerificationCaseV1UpdateDocument } from '../../../../../../generated';
import { AzureBlobResponse } from '../../../../../shared/file-upload/azure-upload';
import { message } from 'antd';

interface FilesContainerProps {
  caseId: string;
  isCaseOrApplicant: string;
}

export const FilesContainer: FC<FilesContainerProps> = (props) => {
  const {
    data: caseData,
    loading,
    error
  } = useQuery(StaffCasesFilesContainerCredentialVerificationCaseV1Document, {
    variables: {
      credentialVerificationCaseV1Id: props.caseId
    }
  });

  const [updatedIdentityVerificationCaseV1] = useMutation(StaffCasesFilesContainerCredentialVerificationCaseV1UpdateDocument);

  const handleOnUploadSuccess = async (response: AzureBlobResponse, fieldName: string) => {
    const input = {
      id: props.caseId,
      assets: {
        private: {
          [fieldName]: response.blobUrl,
          [`${fieldName}Version`]: response.versionId
        }
      }
      // caseDetails: {
      //   application: {
      //     credentialAssets: {
      //       [fieldName]: response.blobUrl,
      //       [`${fieldName}Version`]: response.versionId,
      //     },
      //   },
      // },
    };
    updatedIdentityVerificationCaseV1({
      variables: {
        input
      }
    }).then((res) => {
      if (res.data?.credentialVerificationCaseV1Update?.status?.success) {
        message.success('File uploaded successfully');
      } else {
        message.error('Failed to upload file: ' + res.data?.credentialVerificationCaseV1Update?.status.errorMessage);
      }
    });
  };

  return (
    <ComponentQueryLoader
      loading={loading}
      error={error}
      hasData={caseData?.credentialVerificationCaseV1}
      hasDataComponent={
        <Files
          shared={true}
          caseId={props.caseId}
          onUploadSuccess={(response, fieldname) => handleOnUploadSuccess(response, fieldname)}
          caseState={caseData?.credentialVerificationCaseV1?.state ?? ''}
          isAssigned={caseData?.credentialVerificationCaseV1?.isCurrentUserAssigned ?? false}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }
    />
  );
};
